import { Reveal } from "@/components/Reveal";
import { MANIFESTO } from "@/lib/site";

export default function Manifesto() {
  return (
    <section className="relative py-24 sm:py-32 bg-ink-950 overflow-hidden" data-testid="manifesto-section">
      <div className="absolute top-1/3 -left-40 w-96 h-96 rounded-full bg-violet-500/10 blur-[120px]" />
      <div className="absolute bottom-1/4 -right-40 w-96 h-96 rounded-full bg-pink-500/10 blur-[120px]" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <Reveal className="mb-16">
          <p className="overline mb-4">Our manifesto</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter text-white">Why we do this.</h2>
        </Reveal>

        <div className="space-y-px">
          {MANIFESTO.map((m, i) => {
            const num = ["text-violet-300", "text-pink-300", "text-sky-300"][i % 3];
            const hover = ["hover:border-violet-500/40", "hover:border-pink-500/40", "hover:border-sky-500/40"][i % 3];
            return (
              <Reveal key={m.n} delay={i * 0.08}>
                <div className={`group grid md:grid-cols-12 gap-6 md:gap-10 items-start py-10 border-t border-white/10 transition-colors ${hover}`}>
                  <div className={`md:col-span-2 font-mono-tech text-xl ${num}`}>{m.n}</div>
                  <h3 className="md:col-span-5 font-display font-extrabold text-3xl sm:text-4xl tracking-tighter text-white leading-[0.98] group-hover:translate-x-1 transition-transform">
                    {m.title}
                  </h3>
                  <p className="md:col-span-5 text-lg text-zinc-400 leading-relaxed">{m.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
